import checkout from "./form";

const {
  formField: {
    certificate,
    fullName,
    firstTime,
    signer,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    timeSign,
    nameOfProductionBusinessActivities,
    contractNumber,
    contractDay,
    dependentUnitName,
    dependentUnitNameTaxId,
    addressWard,
    addressDistrict,
    addressCity,
  },
} = checkout;

const initialValues = {
  [certificate.name]: "",
  [fullName.name]: "",
  [firstTime.name]: false,
  [signer.name]: "",
  [supplementaryForThe.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [taxCalculationPeriod.name]: "",
  [taxId.name]: "",
  [taxpayerName.name]: "",
  [timeSign.name]: "",
  [nameOfProductionBusinessActivities.name]: "",
  [contractNumber.name]: "",
  [contractDay.name]: "",
  [dependentUnitName.name]: "",
  [dependentUnitNameTaxId.name]: "",
  [addressWard.name]: "",
  [addressDistrict.name]: "",
  [addressCity.name]: "",
};

export default initialValues;
